import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { setHKS } from 'utils/HKS';
import { showModal, removeModal, clearPasswordData } from 'actions/response';
import { changePassword } from 'action-creators/user/password';
import Metrics from 'services/metrics';
import {
  getLoading,
  getUpdatePasswordError,
  getUpdatePasswordSuccess,
} from 'selectors/user/password';
import {
  getLabels,
  getMessage,
  MODAL_ERROR,
  MODAL_SUCCESS,
  CODE_CLOSE_SESSION,
  CODE_OLD_PASSWORD_ERROR,
  URL_REDIRECT,
} from './constants';
import { hasErrors } from './utils';
import Password from './password';

function PasswordSection({
  user,
  loaded,
  error,
  success,
  onShowModal,
  onCloseModal,
  onUpdatePassword,
  translations,
  onResetPassword
}) {
  const labels = getLabels(translations);
  const [form, setForm] = useState({
    user_hash: user.userhash,
    oldpassword: '',
    newpassword: '',
    controlpassword: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [editEnable, setEditEnable] = useState(false);
  const [loading, setLoading] = useState(false);
  const state = useSelector(state => console.log('state', state))
  console.log('error', error)

  useEffect(
    () => {
      if (loaded) setLoading(true);
      if (error) onFail();
      if (success) onSuccess();
    },
    [loaded, error, success],
  );

  useEffect(()=>{

    return ()=> onResetPassword()
  },[])


  const successRedirect = ()=> {
    success && setHKS('')
    success &&  window.location.replace(URL_REDIRECT);
  }

  const getProps = typeModal => {
    return {
      onAccept: () => {
        onCloseModal(typeModal);
        successRedirect()

      },
      onClose: () => {
        onCloseModal(typeModal);
        successRedirect()
      },
    };
  };

  const displayModal = ({ data, type, props }) => {
    const message = getMessage({...data, translations: translations});
    const modal = {
      modalType: type,
      props: {
        message,
        ...props,
      },
    };
    onShowModal(modal);
  };

  const onSuccess = () => {
    const { code } = success;
    let props = {};
    handleToggle();
    setLoading(false);
    if (code === CODE_CLOSE_SESSION) {
      props = getProps(MODAL_SUCCESS);
    }
    displayModal({ data: success, type: MODAL_SUCCESS, props });
  };

  const onFail = () => {
    const { code } = error;
    let props = {};
    setLoading(false);
    if (code === CODE_OLD_PASSWORD_ERROR) {
      props = getProps(MODAL_ERROR);
    }
    displayModal({ data: error, type: MODAL_ERROR, props });
  };

  const isValid = () => {
    const errors = hasErrors(form, translations);
    if (errors) {
      setFormErrors(errors);
      return false;
    }
    setFormErrors({});
    return true;
  };

  const handleToggle = () => {
    let label = 'Modificar';
    if (editEnable) {
      const emptyForm = {
        oldpassword: '',
        newpassword: '',
        controlpassword: '',
      };
      setFormErrors({});
      setForm({ ...form, ...emptyForm });
      label = 'Cancelar';
    }
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Modificar Contraseña',
      eventLabel: label,
    });
    setEditEnable(!editEnable);
  };

  const handleChange = ({ target }) => {
    setForm({ ...form, [target.name]: target.value });
  };

  const handleSave = e => {
    e.preventDefault();
    if (!isValid()) return;
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Modificar Contraseña',
      eventLabel: 'Guardar',
    });
    onUpdatePassword(form);
  };

  const className = {
    modify: editEnable ? '' : 'pull-right',
  };

  return (
    <Password
      label={labels}
      className={className}
      form={form}
      errors={formErrors}
      isEditMode={editEnable}
      loading={loading}
      onChange={handleChange}
      onSave={handleSave}
      onToggle={handleToggle}
    />
  );
}

PasswordSection.propTypes = {
  user: PropTypes.object,
  loaded: PropTypes.bool,
  error: PropTypes.object,
  success: PropTypes.object,
  onShowModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onUpdatePassword: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  loaded: getLoading(state),
  error: getUpdatePasswordError(state),
  success: getUpdatePasswordSuccess(state),
  translations: state?.translations
});

const mapDispatchToProps = dispatch => ({
  onShowModal(payload) {
    dispatch(showModal(payload));
  },
  onCloseModal(payload) {
    dispatch(removeModal(payload));
  },
  onUpdatePassword(payload) {
    dispatch(changePassword(payload));
  },
  onResetPassword(){
    dispatch(clearPasswordData())
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordSection);
